// a store to manage a collection of items

import {writable,get} from "svelte/store"
import * as api from "./api.js"

export default function(url){

  let store = writable([])
  let allloaded = false
  let loadingSome = false

  // loads all data, using query string if provided, unless already loaded, or force is set to true
  store.loadAll = async function({query,force = false}={}){
    let fullurl = url
    if(query) fullurl+="?"+new URLSearchParams(query).toString() // querystring encoding
    if(!force && allloaded) return // prevent loading twice
    store.set([])
    let res = await api.load({url:fullurl})
    allloaded = true 
    store.set(res.data)
  }

  // used with paging api to load only visible rows
  store.loadSome = async function({query,force = false}={}){
    if(loadingSome) return // prevent loading twice
    let fullurl = url
    const value = get(store)
    let limit = +query.limit || 50
    let offset = +query.offset || 0
    if(value.length && value.length < offset+limit){
      limit = value.length - offset// adjust limit if not enough data
      query.limit = limit
    }
    if(value.length && value.slice(offset,offset+limit).every(row => row.id)) return // if already loaded, check if data is present in store
    if(query) fullurl+="?"+new URLSearchParams(query).toString() // querystring encoding
    loadingSome = true
    let res = await api.load({url:fullurl})
    let data = value.length != res.total ? new Array(res.total).fill({}) : value
    for(let i=0;i<limit;i++) data[i+offset] = ( res.data[i] || {id:"not found"}) // fill in the data
    store.set(data)
    loadingSome = false
  }

  // loads a single record, stores it in this.one, and returns data
  store.loadOne = async function({id,query}){
    let fullurl = url+`/${id}`
    if(query) fullurl+="?"+new URLSearchParams(query).toString() // querystring encoding
    let res = await api.load({url:fullurl})
    return res.data
  }
  
  // update all with updated row, or add new row if not found
  store.patch = function (updated_row){
    store.update((rows)=>{
      let hasUpdated = false
      let updated = rows.map((row)=> row.id == updated_row.id ?	(hasUpdated = true && {...row,...updated_row}) :	row ) // dupe rows, update one if found
      if(!hasUpdated) updated.push(updated_row) // not found add new
      return updated
    })
  }

  // saves data and call update on collection
  store.save = async function({data,method}){
    let res = await api.save({url:url,data, method})
    if(res && res.data){
      let updated_row = res.data
      store.patch(updated_row)
      return updated_row
    }
  }

  // deletes record and removes from collection
  store.delete = async function(record){
    await api.remove({url:url+`/${record.id}`})
    store.update((rows)=> rows.filter(r => r.id != record.id))
  }

  store.reset = function(){
    allloaded = false 
    store.set([])
  }

  return store

}